import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { StudioTaxService, StudioTaxMode, enrollmentWithTax } from 'src/app/services/studio-tax.service';
import { NgForm, FormBuilder } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ViewTableComponent } from '../../base/view-table/view-table.component';
import moment from 'moment';
import flatpickr from 'flatpickr';
import { LocalizationService } from 'src/app/services/localization.service';
import { EnrollmentEntityComponent } from '../../forms/enrollment-entity/enrollment-entity.component';
import { StudentDashboardWrapperComponent } from '../../student/student-dashboard-wrapper/student-dashboard-wrapper.component';
import { ViewPaymentsFromEnrollmentComponent } from '../../forms/view-payments-from-enrollment/view-payments-from-enrollment.component';
import { ViewPaymentsDueFromEnrollmentComponent } from '../../forms/view-payments-due-from-enrollment/view-payments-due-from-enrollment.component';
import { PageEvent } from '@angular/material/paginator';
import { HttpParameter } from 'src/app/types/http-parameter';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FieldsService } from 'src/app/services/fields.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RefreshService } from 'src/app/services/refresh.service';
import { Params } from '@angular/router';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { LessonAdjustmentDialogComponent } from '../../forms/lesson-adjustment-dialog/lesson-adjustment-dialog.component';
import { PrintService } from 'src/app/services/print.service';
import { LoggerService } from '../../../services/logger.service';
@Component({
  selector: 'app-enrollments-list',
  templateUrl: './enrollments-list.component.html',
  styleUrls: ['./enrollments-list.component.css']
})
export class EnrollmentsListComponent extends ViewTableComponent implements OnInit, OnDestroy, AfterViewInit {

  // Subscription to the refresh service
  private refreshSubscription: Subscription;
  private studioCountrySubscription: Subscription;
  private taxModeSubscription: Subscription;
  private saleDatePickerConfigSubscription: Subscription;

  // Date range properties
  @ViewChild('saleDateRangeInput') saleDateRangeInput!: ElementRef;
  saleDateRange: Date[] = [];
  saleDateRangeDisplayValue: string = '';
  private saleDateRangePicker?: flatpickr.Instance;
  displayDateFormatMoment = 'MM/DD/YYYY';

  override displayedColumns: string[] = [
    'enrollmentID',
    'field_contacts',
    'field_sale_date',
    'field_instructor',
    'field_executive',
    'field_category',
    'field_package_name',
    'AllEnrollmentInstructors',
    'field_enrollment_lesson_count',
    'field_enrollment_total_price',
    'field_total_paid',
    'field_balance_due',
    'field_additional_notes',
    'field_lesson_available',
    'isDropped',
    'field_notes',
    // 'nothing',
    'nothing_1',
  ];

  StudentDashboardWrapperComponent = StudentDashboardWrapperComponent;
  ViewPaymentsFromEnrollmentComponent = ViewPaymentsFromEnrollmentComponent;
  ViewPaymentsDueFromEnrollmentComponent = ViewPaymentsDueFromEnrollmentComponent;

  isExporting: boolean = false;

  private _printService: PrintService;

  constructor(
    refreshService: RefreshService,
    dialogService: DialogService,
    entityRESTService: EntityRESTService,
    utilityService: UtilityService,
    fieldsService: FieldsService,
    drupalRESTService: DrupalRESTService,
    taxonomyService: TaxonomyService,
    router: Router,
    activatedRoute: ActivatedRoute,
    authRESTService: AuthRESTService,
    authService: AuthService,
    menuRESTService: MenuRESTService,
    formBuilder: FormBuilder,
    routeEventsService: RouteEventsService,
    permissionsService: PermissionsService,
    renderer2: Renderer2,
    configPages: ConfigPagesService,
    packagesService: PackagesService,
    snackBar: MatSnackBar,
    userRESTService: UserService,
    el: ElementRef,
    changeDetectorRef: ChangeDetectorRef,
    sanitizer: DomSanitizer,
    private componentRefreshService: ComponentRefreshService,
    private studioConfigService: StudioConfigService,
    private translateService: TranslateService,
    private dialog: MatDialog,
    private localizationService: LocalizationService,
    private studioTaxService: StudioTaxService
  ) {
    super(
      refreshService,
      dialogService,
      entityRESTService,
      utilityService,
      fieldsService,
      drupalRESTService,
      taxonomyService,
      router,
      activatedRoute,
      authRESTService,
      authService,
      menuRESTService,
      formBuilder,
      routeEventsService,
      permissionsService,
      renderer2,
      configPages,
      packagesService,
      snackBar,
      userRESTService,
      el,
      changeDetectorRef,
      sanitizer,
      studioConfigService,
      componentRefreshService,
      translateService
    );
    // Exclusive-tax studios (Canadian GST/HST/PST) see tax-inclusive totals so the
    // list matches what the customer owes/paid; re-annotate if the mode resolves
    // after the rows did.
    this.taxModeSubscription = this.studioTaxService.getTaxMode().subscribe(mode => {
      this.taxMode = mode;
      this.annotateWithTax(this.dataSource?.data);
    });
  }

  /** Studio tax mode; null until the studio's tax config has loaded. */
  taxMode: StudioTaxMode | null = null;

  /**
   * Attach `withTax` {total, paid, due, totalTax, paidTax, dueTax} to each
   * row, or null when nothing to add. Rows carry paid_tax_actual /
   * paid_gross_actual from /api/v1/enrollment-list, so the paid tax reflects
   * what the payments really collected instead of a rate proration (which
   * can land a cent off: $7,499.99 instead of $7,500.00).
   */
  private annotateWithTax(rows: any[] | undefined): void {
    if (!rows) return;
    rows.forEach(row => {
      row.withTax = row.isAdjustmentRow ? null : enrollmentWithTax(row, this.taxMode);
    });
  }

  override ngOnInit() {
    this.studioCountrySubscription = this.studioConfigService.getCountryCode().subscribe(countryCode => {
      const formats = this.localizationService.getDateFormatsForCountry(countryCode);
      this.displayDateFormatMoment = formats.calendarDateFormat;
    });

    // Initialize pagination values
    this.paginationIndex = 0;
    this.pageSize = 25;  // Set default page size

    // Setup refresh service before parent initialization
    this.refreshSubscription = this.componentRefreshService.enrollmentsListRefresh$.subscribe(() => {
      LoggerService.log('EnrollmentsListComponent: Received refresh event');
      this.refreshData();
    });

    // Call parent ngOnInit - this will trigger getData, but our flag will prevent duplicate API call
    super.ngOnInit();

    // Standalone PrintService (parent's 25-arg constructor doesn't expose
    // it; mirror the students-list pattern).
    this._printService = new PrintService(this._drupalRESTService, this._authService);
  }

  override ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
    if (this.studioCountrySubscription) {
      this.studioCountrySubscription.unsubscribe();
    }
    this.taxModeSubscription?.unsubscribe();
    this.saleDatePickerConfigSubscription?.unsubscribe();
    this.saleDateRangePicker?.destroy();

    // Call parent ngOnDestroy if it exists
    super.ngOnDestroy();
  }

  /**
   * Refreshes the data while preserving pagination state
   */
  refreshData(): void {
    LoggerService.log('EnrollmentsListComponent: Refreshing data with pagination state');

    // Add current pagination state to the query params
    const paginationParams: HttpParameter[] = [
      { parameter: 'page', value: this.paginationIndex.toString() },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ];

    // Combine filters with pagination
    const paramsWithPagination = [...this.queryParams, ...paginationParams];

    this.getData(paramsWithPagination);
  }

  /**
* Handles sale date range change
*/
  ngAfterViewInit(): void {
    this.initSaleDateRangePicker();
  }

  private initSaleDateRangePicker(): void {
    if (!this.saleDateRangeInput?.nativeElement) return;

    this.saleDatePickerConfigSubscription?.unsubscribe();
    this.saleDatePickerConfigSubscription = this._studioConfigService.getStudioConfig().subscribe(config => {
      const countryCode = config?.['field_studio_address']?.[0]?.country_code || 'US';
      const formats = this.localizationService.getDateFormatsForCountry(countryCode);

      this.saleDateRangePicker = flatpickr(this.saleDateRangeInput.nativeElement, {
        mode: 'range',
        dateFormat: formats.flatpickrDateFormat,
        disableMobile: true,
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            this.saleDateRange = selectedDates;
            this.saleDateRangeDisplayValue = this.saleDateRangePicker?.input?.value || '';

            const params: { parameter: string; value: string; }[] = [];
            params.push({
              parameter: 'field_sale_date',
              value: `${this.reportDateService.formatCalendarParam(this.saleDateRange[0])}--${this.reportDateService.formatCalendarParam(this.saleDateRange[1])}`
            });
            this.getData(params);
          }
        }
      });
    });
  }

  openSaleDateRangePicker(): void {
    this.saleDateRangePicker?.open();
  }

  override onSubmit(form: NgForm): void {
    const params: { parameter: string; value: string; }[] = [];

    // Handle date range separately
    if (this.saleDateRange && this.saleDateRange[0] && this.saleDateRange[1]) {
      params.push({
        parameter: 'field_sale_date',
        value: `${this.reportDateService.formatCalendarParam(this.saleDateRange[0])}--${this.reportDateService.formatCalendarParam(this.saleDateRange[1])}`
      });
    }

    // Handle other form values, excluding the date field
    Object.keys(form.value).forEach(key => {
      if (form.value[key] && key !== 'field_sale_date_value') {
        params.push({
          parameter: key,
          value: form.value[key]
        });
      }
    });

    this.getData(params);
  }

  override getData(params: { parameter: string; value: string; }[]) {
    // Show Progress Bar (Loading indicator)
    this.ShowProgressBar = true;

    // Store only non-pagination params in queryParams
    this.queryParams = params.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    // Add current pagination state to params if not present
    let finalParams = [...params];
    if (!params.some(p => p.parameter === 'page')) {
      finalParams.push(
        { parameter: 'page', value: this.paginationIndex.toString() },
        { parameter: 'items_per_page', value: this.pageSize.toString() }
      );
    }

    // Add sorting parameters if available
    if (this.sortParams !== undefined) {
      finalParams.push(this.sortParams);
    }

    // New ami_enrollment_list module. The legacy /api/v1/enrollment_list
    // (underscore) View route stays live during the transition for any
    // external integration still pointed at it.
    this._drupalRESTService.httpGET("/api/v1/enrollment-list", finalParams)
      .subscribe((data) => {
        this.ShowProgressBar = false;
        this.data = data;

        // Check if current page is empty and we're not on the first page
        // This can happen after deleting the last item(s) on a page
        if (data['results'] && data['results'].length === 0 && this.paginationIndex > 0) {
          LoggerService.log('Current page is empty after deletion, going back one page');
          this.paginationIndex = Math.max(0, this.paginationIndex - 1);

          // Recursively call getData with the new page index
          const updatedParams = params.map(p =>
            p.parameter === 'page'
              ? { parameter: 'page', value: this.paginationIndex.toString() }
              : p
          );
          this.getData(updatedParams);
          return;
        }

        // Process data to add dropped enrollment rows
        const processedData = this.processDroppedEnrollments(data['results']);
        this.annotateWithTax(processedData);
        this.dataSource = new MatTableDataSource(processedData);

        // Pagination
        if (data['results']) {
          this.setupPagination(data, params);
        }

      }, error => this.handleError(error))
  }

  /**
   * Process dropped enrollments to add adjustment rows
   */
  processDroppedEnrollments(enrollments: any[]): any[] {
    if (!enrollments || enrollments.length === 0) {
      return [];
    }

    const processedData = [...enrollments];
    let insertOffset = 0; // Track how many rows we've inserted

    // Find dropped enrollments and create adjustment rows
    enrollments.forEach((enrollment, index) => {
      if (enrollment.field_dropped_date) {
        // Create a single adjustment row for this dropped enrollment
        const adjustmentRow = { ...enrollment };

        // Mark as an adjustment row
        adjustmentRow.isAdjustmentRow = true;
        adjustmentRow.showTotals = true;

        // Ensure the adjustment row is also marked as a dropped enrollment
        // This will help with styling consistency
        adjustmentRow.field_dropped_date = enrollment.field_dropped_date;

        // Generate a unique ID for the adjustment row
        adjustmentRow.id = `${enrollment.id}-adjustment`;

        // Special handling for miscellaneous enrollments (category 5)
        // Note: Need to use both '5' and 5 in comparisons since the field can be either string or number
        const isMiscellaneous = enrollment.field_category === '5' || enrollment.field_category === 5;
        const isSundry = enrollment.field_category === '67' || enrollment.field_category === 67;
        const isSpecialCategory = isMiscellaneous || isSundry;

        const lessonsUsed = enrollment.field_lesson_used ? parseInt(enrollment.field_lesson_used) : 0;
        const totalLessons = parseInt(enrollment.field_enrollment_lesson_count) || (isSpecialCategory ? 1 : 0);
        const unusedLessons = isSpecialCategory ? 1 : (totalLessons - lessonsUsed);

        // Calculate the per-lesson price (handle special case for category 5)
        const totalPrice = parseFloat(enrollment.field_enrollment_total_price);
        const lessonPrice = isSpecialCategory ? totalPrice : (totalPrice / (totalLessons || 1));

        // Store original values for display
        adjustmentRow.originalLessonCount = isSpecialCategory ? "1" : enrollment.field_enrollment_lesson_count;
        adjustmentRow.originalTotalPrice = enrollment.field_enrollment_total_price;
        adjustmentRow.originalTotalPaid = enrollment.field_total_payments_made;
        adjustmentRow.originalBalanceDue = enrollment.field_balance_due;

        // Set the adjustment values (only subtract the unused lessons)
        const adjustmentLessonCount = isSpecialCategory ? "-1" : `-${unusedLessons}`;

        // Calculate the price for unused lessons
        const unusedLessonsPrice = (unusedLessons * lessonPrice).toFixed(2);
        const adjustmentTotalPrice = isSpecialCategory ? `-${totalPrice.toFixed(2)}` : `-${unusedLessonsPrice}`;

        // Calculate adjustments for payments and balance due
        let adjustmentTotalPaid = "0";
        let adjustmentBalanceDue = "0";

        // Determine if payment was made only for lessons taken or for all lessons
        const isByTheLesson = enrollment.field_payments_structure_type === "By The Lesson";

        // Check if the amount paid corresponds to lessons taken or total lessons
        let paidForLessonsTaken = false;

        if (enrollment.field_total_payments_made) {
          const totalPaid = parseFloat(enrollment.field_total_payments_made);
          const expectedPaymentForUsedLessons = lessonsUsed * lessonPrice;

          // If the payment is close to the expected payment for used lessons (within $1 to account for rounding)
          // or if it's a "By The Lesson" payment structure, assume they paid only for lessons taken
          paidForLessonsTaken = Math.abs(totalPaid - expectedPaymentForUsedLessons) < 1 || isByTheLesson;

          // For cases where they paid only for lessons taken
          if (paidForLessonsTaken) {
            // No adjustment needed for payments
            adjustmentTotalPaid = "0";
          } else {
            // For cases where they paid for all lessons, calculate proportional adjustment
            // For miscellaneous enrollments, we need to refund the entire amount
            if (isSpecialCategory) {
              adjustmentTotalPaid = `-${totalPaid.toFixed(2)}`;
            } else {
              const paidPerLesson = totalPaid / totalLessons;
              const unusedPaid = (unusedLessons * paidPerLesson).toFixed(2);
              adjustmentTotalPaid = `-${unusedPaid}`;
            }
          }
        }

        if (enrollment.field_balance_due) {
          const balanceDue = parseFloat(enrollment.field_balance_due);

          // If they paid only for lessons taken, the balance due is likely for unused lessons
          if (paidForLessonsTaken) {
            // The balance due should be reduced by the full amount of unused lessons
            if (isSpecialCategory) {
              adjustmentBalanceDue = `-${balanceDue.toFixed(2)}`;
            } else {
              const unusedDue = (unusedLessons * lessonPrice).toFixed(2);
              adjustmentBalanceDue = `-${unusedDue}`;
            }
          } else {
            // For other cases, calculate proportional adjustment
            if (isSpecialCategory) {
              adjustmentBalanceDue = `-${balanceDue.toFixed(2)}`;
            } else {
              const duePerLesson = balanceDue / totalLessons;
              const unusedDue = (unusedLessons * duePerLesson).toFixed(2);
              adjustmentBalanceDue = `-${unusedDue}`;
            }
          }
        }

        // Calculate final values after adjustment
        const finalLessonCount = isSpecialCategory ? 0 : lessonsUsed;
        const finalTotalPrice = isSpecialCategory ? "0.00" : (parseFloat(enrollment.field_enrollment_total_price) - parseFloat(unusedLessonsPrice)).toFixed(2);

        let finalTotalPaid = "0";
        if (isSpecialCategory) {
          finalTotalPaid = "0.00";
        } else if (!paidForLessonsTaken && enrollment.field_total_payments_made) {
          const totalPaid = parseFloat(enrollment.field_total_payments_made);
          const paidPerLesson = totalPaid / totalLessons;
          const usedPaid = (lessonsUsed * paidPerLesson).toFixed(2);
          finalTotalPaid = usedPaid;
        } else if (paidForLessonsTaken && enrollment.field_total_payments_made) {
          finalTotalPaid = enrollment.field_total_payments_made;
        }

        let finalBalanceDue = "0";
        if (isSpecialCategory) {
          finalBalanceDue = "0.00";
        } else if (paidForLessonsTaken) {
          // For cases where they paid only for lessons taken, calculate balance due for lessons taken but not paid
          const lessonsTakenNotPaid = lessonsUsed - (parseFloat(enrollment.field_total_payments_made || "0") / lessonPrice);
          finalBalanceDue = (lessonsTakenNotPaid > 0 ? lessonsTakenNotPaid * lessonPrice : 0).toFixed(2);
        } else if (enrollment.field_balance_due) {
          const balanceDue = parseFloat(enrollment.field_balance_due);
          const duePerLesson = balanceDue / totalLessons;
          const usedDue = (lessonsUsed * duePerLesson).toFixed(2);
          finalBalanceDue = usedDue;
        }

        // Store adjustment and final values
        adjustmentRow.adjustmentLessonCount = adjustmentLessonCount;
        adjustmentRow.adjustmentTotalPrice = adjustmentTotalPrice;
        adjustmentRow.adjustmentTotalPaid = adjustmentTotalPaid;
        adjustmentRow.adjustmentBalanceDue = adjustmentBalanceDue;

        adjustmentRow.finalLessonCount = finalLessonCount;
        adjustmentRow.finalTotalPrice = finalTotalPrice;
        adjustmentRow.finalTotalPaid = finalTotalPaid;
        adjustmentRow.finalBalanceDue = finalBalanceDue;

        // Set lessons available to 0 for the adjustment
        adjustmentRow.field_lesson_available = "0";

        // Insert the adjustment row immediately after the dropped enrollment
        // We need to account for previously inserted rows, so we use the original index + offset
        processedData.splice(index + insertOffset + 1, 0, adjustmentRow);
        insertOffset++;
      }
    });

    return processedData;
  }

  override resetForm() {
    // Clear all stored params
    this.queryParams = [];
    this.sortParams = undefined;

    // Reset pagination
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginationIndex = 0;  // Reset the pagination index
      this.pageSize = 25;  // Reset page size
    }

    // Clear the form
    this.form.resetForm();

    // Clear any autocomplete options
    this.autoCompleteStudentAccountOptions = [];
    this.autoCompletePackageOptions = [];

    // Sale-date range is owned by flatpickr (outside the ngForm). Also
    // clear the picker, its mirror state, and the visible input.
    this.saleDateRange = [];
    this.saleDateRangeDisplayValue = '';
    this.saleDateRangePicker?.clear();

    // Make a fresh request with explicitly empty params
    this.getData([
      { parameter: 'page', value: '0' },
      { parameter: 'items_per_page', value: '10' }
    ]);

    // Update router last
    this.updateRouterParams({});
  }

  override pageChanged(event: PageEvent) {
    LoggerService.log('Custom pageChanged called...');

    // Update pagination state
    this.paginationIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    // Always include pagination parameters
    const paginationParams: HttpParameter[] = [
      { parameter: 'page', value: this.paginationIndex.toString() },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ];

    // Preserve current filters (exclude any existing pagination params)
    const filteredQueryParams = this.queryParams.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    // Combine and fetch
    const combinedParams = [...filteredQueryParams, ...paginationParams];
    this.getData(combinedParams);
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    // Check if paginator exists before accessing its properties
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      // Use the stored paginationIndex instead of params to preserve pagination state
      this.paginator.pageIndex = this.paginationIndex;
    }

    // DO NOT call updateRouterParams here - this prevents duplicate requests
    // The routing has already been handled by pageChanged() or other methods
    LoggerService.log('setupPagination called - skipping route update to prevent duplicates');
  }

  override onPageSizeOptions() {
    return [10, 25, 50, 100, 250];
  }

  exportEnrollmentList() {
    this.isExporting = true;
    const paramArray = [...this.queryParams, { parameter: '_format', value: 'csv' }];
    this._drupalRESTService.downloadFile('/api/v1/enrollment-list/export', paramArray)
      .subscribe({
        next: (response: any) => {
          const blob = new Blob([response.body], { type: response.type });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', 'enrollment_list_' + new Date().toISOString().slice(0, 10) + '.csv');
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.isExporting = false;
        },
        error: (err) => {
          LoggerService.error('Error downloading enrollment CSV:', err);
          this._snackBar.open('Error downloading enrollment list', 'Close', { duration: 3000 });
          this.isExporting = false;
        },
      });
  }

  printEnrollmentList() {
    const rows: any[] = (this.dataSource?.data ?? []) as any[];

    const escape = (v: any) => {
      const s = v === null || v === undefined ? '' : String(v);
      return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    };
    const formatDate = (v: any) => {
      if (!v) return '';
      const m = moment(v);
      return m.isValid() ? m.format('M/D/YYYY') : '';
    };
    const money = (v: any) => {
      if (v === null || v === undefined || v === '') return '';
      const n = parseFloat(String(v));
      if (isNaN(n)) return String(v);
      return n.toFixed(2);
    };

    const headers = [
      'Enrollment', 'Student', 'Sale Date',
      'Instructor', 'Executive', 'Category', 'Package',
      'Lessons', 'Total Price', 'Total Paid', 'Balance Due', 'Remaining',
    ];
    const headerHtml = headers.map(h => `<th>${escape(h)}</th>`).join('');

    const bodyHtml = rows
      // Skip adjustment rows on print. The row we print is the parent enrollment
      // and the adjustment is a UI-only artifact for the on-screen table.
      .filter(r => !r.isAdjustmentRow)
      .map((r: any) => {
        const dropped = !!r.field_dropped_date;
        const droppedStyle = dropped ? ' style="color:#888;font-style:italic;"' : '';
        const instructor = `${r.field_first_name || ''} ${r.field_last_name || ''}`.trim();
        const executive = `${r.field_executive_first_name || ''} ${r.field_executive_last_name || ''}`.trim();
        return `<tr${droppedStyle}>
          <td class="nowrap">${escape(r.id)}${dropped ? ' (dropped)' : ''}</td>
          <td>${escape(r.field_contacts)}</td>
          <td class="nowrap">${escape(formatDate(r.field_sale_date))}</td>
          <td>${escape(instructor)}</td>
          <td>${escape(executive)}</td>
          <td>${escape(r.field_category)}</td>
          <td>${escape(r.field_enrollment_package_name)}</td>
          <td class="num">${escape(r.field_enrollment_lesson_count)}</td>
          <td class="num">${escape(money(r.field_enrollment_total_price))}</td>
          <td class="num">${escape(money(r.field_total_payments_made))}</td>
          <td class="num">${escape(money(r.field_balance_due))}</td>
          <td class="num">${escape(r.field_lesson_available)}</td>
        </tr>`;
      }).join('');

    const filterSummary = this.buildPrintFilterSummary();
    const summaryHtml = filterSummary
      ? `<div class="filter-summary"><strong>Filters:</strong> ${escape(filterSummary)}</div>`
      : '';
    const dataRows = rows.filter(r => !r.isAdjustmentRow);
    const countHtml = `<div class="row-count">${dataRows.length} enrollment${dataRows.length === 1 ? '' : 's'}</div>`;

    const content = `
      <h1 class="report-title">Enrollment List</h1>
      ${summaryHtml}
      ${countHtml}
      <table class="report-table">
        <thead><tr>${headerHtml}</tr></thead>
        <tbody>${bodyHtml}</tbody>
      </table>
    `;

    const styles = `
      @page { size: letter landscape; margin: 0.5in; }
      .report-table { width: 100%; border-collapse: collapse; font-size: 10px; }
      .report-table th, .report-table td { border: 1px solid #ccc; padding: 3px 5px; }
      .report-table th { background: #f0f0f0; }
      .report-table td.num { text-align: right; }
      .report-table td.nowrap { white-space: nowrap; }
      .filter-summary { margin: 4px 0; font-size: 11px; }
      .row-count { margin: 4px 0 8px 0; font-size: 11px; color: #555; }
    `;

    this._printService.print(content, {
      title: 'Enrollment List',
      styles,
      showSchoolName: true,
      promptPrint: true,
    });
  }

  private buildPrintFilterSummary(): string {
    const params = this.queryParams || [];
    const parts: string[] = [];
    for (const p of params) {
      if (!p || !p.parameter || !p.value) continue;
      if (p.parameter === 'field_sale_date') {
        parts.push(`Sale Date: ${p.value.replace('--', ' to ')}`);
      } else if (p.parameter === 'instructor') {
        const instructors = this._fieldsService.instructorData() || [];
        const m = instructors.find((i: any) => String(i.uid) === String(p.value));
        parts.push(`Instructor: ${m ? m.value : p.value}`);
      } else if (p.parameter === 'executive') {
        const executives = this._fieldsService.executiveData || [];
        const m = executives.find((e: any) => String(e.uid) === String(p.value));
        parts.push(`Executive: ${m ? m.value : p.value}`);
      } else if (p.parameter === 'field_category_target_id') {
        parts.push(`Category: ${p.value}`);
      } else if (p.parameter === 'title') {
        parts.push(`Student: ${p.value}`);
      } else if (p.parameter === 'field_package_name_value') {
        parts.push(`Package: ${p.value}`);
      } else if (p.parameter === 'field_package_id_value') {
        parts.push(`Enrollment ID: ${p.value}`);
      }
    }
    return parts.join(' • ');
  }

  isInteger(value: string): boolean {
    if (value && !isNaN(+value)) {
      return Number(value) % 1 === 0;
    }
    return false;
  }

  formatEnrollmentDate(value: string | null | undefined, format: string = this.displayDateFormatMoment): string {
    if (!value) {
      return '';
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return moment(value, 'YYYY-MM-DD', true).format(format);
    }

    const zonedDate = moment.parseZone(value);
    if (zonedDate.isValid()) {
      return zonedDate.format(format);
    }

    const parsedDate = moment(value);
    return parsedDate.isValid() ? parsedDate.format(format) : value;
  }

  /**
   * Opens the lesson adjustment dialog for an enrollment
   * @param enrollmentId - The enrollment ID to adjust
   */
  openAdjustmentDialog(enrollmentId: string) {
    // Load the full enrollment entity data to get all fields including adjustments
    this._drupalRESTService.httpGET('/packages/' + enrollmentId, [{ parameter: '_format', value: 'json' }])
      .subscribe(fullEnrollmentData => {
        const dialogRef = this.dialog.open(LessonAdjustmentDialogComponent, {
          width: '800px',
          height: 'auto',
          maxHeight: '90vh',
          data: {
            enrollmentId: enrollmentId,
            enrollment: fullEnrollmentData
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // Dialog was saved successfully, refresh the data
            this.refreshData();
          }
        });
      }, error => {
        LoggerService.error('Error loading enrollment data:', error);
        // Fallback to using the data from the list view
        const enrollment = this.dataSource.data.find((item: any) => item.id === enrollmentId);

        const dialogRef = this.dialog.open(LessonAdjustmentDialogComponent, {
          width: '800px',
          height: 'auto',
          maxHeight: '90vh',
          data: {
            enrollmentId: enrollmentId,
            enrollment: enrollment
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.refreshData();
          }
        });
      });
  }

  /**
   * Whether the selected studio owns an enrollment. A gift certificate
   * enrollment redeemed here but sold by another studio is listed read-only:
   * the backend forbids edits, and hiding the actions says so up front.
   */
  ownsEnrollment(studioId: any): boolean {
    if (studioId === undefined || studioId === null || studioId === '') {
      return true;
    }
    return +studioId === +(this._authService.selectedStudio?.id);
  }
}
